import React, { useMemo } from "react";
import { MapContainer, TileLayer, Marker, Popup, Circle, LayersControl, AttributionControl } from "react-leaflet";
import L from "leaflet";

function scoreIcon(score) {
  const color = score >= 75 ? "#059669" : score >= 55 ? "#C5A059" : "#94a3b8";
  return L.divIcon({
    className: "opp-marker",
    html: `<div style="background:${color};color:#fff;width:34px;height:34px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);display:flex;align-items:center;justify-content:center;border:2px solid #fff;box-shadow:0 2px 6px rgba(0,0,0,.3)"><span style="transform:rotate(45deg);font-size:11px;font-weight:700">${score}</span></div>`,
    iconSize: [34, 34], iconAnchor: [17, 34],
  });
}

export default function OpportunityMap({ candidates = [], target, radiusKm, height = "460px", onSelect }) {
  const pts = candidates.filter((c) => c.property.lat && c.property.lng);
  const center = useMemo(() => {
    if (target) return [target.lat, target.lng];
    if (pts.length) return [pts[0].property.lat, pts[0].property.lng];
    return [39.5, -8];
  }, [target, pts]);

  return (
    <div className="rounded-sm overflow-hidden border border-slate-200" style={{ height }} data-testid="opportunity-map">
      <MapContainer center={center} zoom={target ? 11 : 6} style={{ height: "100%", width: "100%" }} scrollWheelZoom attributionControl={false}>
        <AttributionControl prefix={false} />
        <LayersControl position="topright">
          <LayersControl.BaseLayer checked name="Map">
            <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          </LayersControl.BaseLayer>
          <LayersControl.BaseLayer name="Satellite">
            <TileLayer attribution="Tiles &copy; Esri" url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}" />
          </LayersControl.BaseLayer>
        </LayersControl>
        {target && radiusKm && (
          <Circle center={[target.lat, target.lng]} radius={radiusKm * 1000}
            pathOptions={{ color: "#0B2545", fillColor: "#0B2545", fillOpacity: 0.06, weight: 1.5, dashArray: "6 6" }} />
        )}
        {pts.map((c) => (
          <Marker key={c.property.id} position={[c.property.lat, c.property.lng]} icon={scoreIcon(c.score.opportunity_score)}
            eventHandlers={{ click: () => onSelect && onSelect(c) }}>
            <Popup>
              <div className="text-sm font-medium">{c.property.title}</div>
              <div className="text-xs text-slate-500">{c.property.city} · {c.property.category}</div>
              <div className="text-xs mt-1">Opportunity: <b>{c.score.opportunity_score}/100</b></div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
